import { MapAuditStatus, MapAuditStatusColor } from '../contractCenter'

/**
 * 客户授信状态（1：未授信 orange、2：授信中 blue、3：已授信 green、4：已冻结 red））
 */
export enum CreditStatus {
  UNCREDITED = 0,
  CREDITING = 1,
  CREDITED = 2,
  FROZEN = 3,
}
/**
 * 授信状态名称（1：未授信 orange、2：授信中 blue、3：已授信 green、4：已冻结 red））
 */
export enum CreditStatusName {
  UNCREDITED = '未授信',
  CREDITING = '授信中',
  CREDITED = '已授信',
  FROZEN = '已冻结',
}
/**
 * 授信状态颜色（1：未授信 orange、2：授信中 blue、3：已授信 green、4：已冻结 red））
 */
export enum CreditStatusColor {
  UNCREDITED = 'orange',
  CREDITING = 'blue',
  CREDITED = 'green',
  FROZEN = 'red',
}
// 状态 0已生效 1已冻结  2清盘中 3已清盘 4已过期 5待生效）
export enum CustomerStatus {
  TASK_EFFECT,
  FREEZE,
  INLIQUIDATION,
  LIQUIDATION,
  OVERDUE,
  WATING_TASK_EFFECT,
}
export enum CustomerStatusName {
  TASK_EFFECT = '已生效',
  FREEZE = '已冻结',
  INLIQUIDATION = '清盘中',
  LIQUIDATION = '已清盘',
  OVERDUE = '已过期',
  WATING_TASK_EFFECT = '待生效',
}
export enum CustomerStatusColor {
  TASK_EFFECT = 'green',
  FREEZE = 'red',
  INLIQUIDATION = 'blue',
  LIQUIDATION = 'lime',
  OVERDUE = 'orange',
  WATING_TASK_EFFECT = 'purple',
}

//办学类型
export enum ESchoolType {
  PRIMARY_SCHOOL = 1, // 小学
  JUNIOR_HIGH_SCHOOL = 2, // 初中
  HIGH_SCHOOL = 3, // 高中
  NINE_YEAR_CONSISTENT = 4, // 九年一贯
  TWELVE_YEAR_CONSISTENT = 5, // 十二年一贯
  COMPLETE_HIGH_SCHOOL = 6, // 完全高中
  VOCATIONAL_HIGH_SCHOOL = 7, // 职高
  TECHNICAL_SCHOOL = 8, // 技工
  SECONDARY_TECHNICAL_SCHOOL = 9, // 中专
  OTHER_SPECIAL_EDUCATION_SCHOOL = 10, // 其他特教学校
  SCHOOL_FOR_MENTAL_RETARDATION = 11, // 培智学校
  DEAF_SCHOOL = 12, // 聋人学校
  BLIND_SCHOOL = 13, // 盲人学校
  CENTRAL_EDU_DEPT_COMPREHENSIVE_UNIV = 14, // 中央教育部门-综合大学-大学
  PROVINCIAL_EDU_DEPT_POLYTECHNIC_UNIV = 15, // 省级教育部门-理工院校-大学
  PROVINCIAL_EDU_DEPT_AGRICULTURAL_UNIV = 16, // 省级教育部门-农业院校-大学
  PROVINCIAL_EDU_DEPT_FORESTRY_UNIV = 17, // 省级教育部门-林业院校-大学
  PROVINCIAL_EDU_DEPT_MEDICAL_UNIV = 18, // 省级教育部门-医药院校-大学
  PROVINCIAL_EDU_DEPT_NORMAL_UNIV = 19, // 省级教育部门-师范院校-大学
  PREFECTURAL_EDU_DEPT_NORMAL_UNIV = 20, // 地级教育部门-师范院校-大学
  PREFECTURAL_EDU_DEPT_NORMAL_COLLEGE = 21, // 地级教育部门-师范院校-学院
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_COLLEGE = 22, // 地级教育部门-综合大学-学院
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_UNIV = 23, // 地级教育部门-综合大学-大学
  PROVINCIAL_EDU_DEPT_FINANCE_ECONOMICS_UNIV = 24, // 省级教育部门-财经院校-大学
  PROVINCIAL_EDU_DEPT_COMPREHENSIVE_COLLEGE = 25, // 省级教育部门-综合大学-学院
  PROVINCIAL_EDU_DEPT_ART_COLLEGE = 26, // 省级教育部门-艺术院校-学院
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = 27, // 地级教育部门-综合大学-高等职业学校
  PROVINCIAL_OTHER_DEPT_POLYTECHNIC_COLLEGE = 28, // 省级其他部门-理工院校-学院
  PROVINCIAL_EDU_DEPT_POLYTECHNIC_COLLEGE = 29, // 省级教育部门-理工院校-学院
  PREFECTURAL_EDU_DEPT_POLYTECHNIC_COLLEGE = 30, // 地级教育部门-理工院校-学院
  PROVINCIAL_OTHER_DEPT_POLITICAL_LAW_COLLEGE = 31, // 省级其他部门-政法院校-学院
  PROVINCIAL_EDU_DEPT_COMPREHENSIVE_UNIV_DUPLICATE = 32, // 省级教育部门-综合大学-大学 (注意：此编号与14重复，实际使用中可能需要调整)
  PROVINCIAL_EDU_DEPT_LANGUAGE_COLLEGE = 33, // 省级教育部门-语文院校-学院
  PRIVATE_COMPREHENSIVE_COLLEGE = 34, // 民办-综合大学-学院
  PROVINCIAL_OTHER_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = 35, // 省级其他部门-理工院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = 36, // 省级其他部门-财经院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = 37, // 省级其他部门-综合大学-高等职业学校
  PRIVATE_LANGUAGE_COLLEGE = 38, // 民办-语文院校-学院
  PROVINCIAL_OTHER_DEPT_ART_VOCATIONAL_COLLEGE = 39, // 省级其他部门-艺术院校-高等职业学校
  PRIVATE_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = 40, // 民办-财经院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_POLITICAL_LAW_VOCATIONAL_COLLEGE = 41, // 省级其他部门-政法院校-高等职业学校
  PROVINCIAL_EDU_DEPT_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = 42, // 省级教育部门-财经院校-高等职业学校
  PRIVATE_POLYTECHNIC_VOCATIONAL_COLLEGE = 43, // 民办-理工院校-高等职业学校
  PRIVATE_FINANCE_ECONOMICS_COLLEGE = 44, // 民办-财经院校-学院
  PRIVATE_COMPREHENSIVE_VOCATIONAL_COLLEGE = 45, // 民办-综合大学-高等职业学校
  COUNTY_OTHER_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = 46, // 县级其他部门-综合大学-高等职业学校
  PROVINCIAL_OTHER_DEPT_MEDICAL_COLLEGE = 47, // 省级其他部门-医药院校-学院
  PREFECTURAL_EDU_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = 48, // 地级教育部门-理工院校-高等职业学校
  PRIVATE_POLYTECHNIC_VOCATIONAL_UNDERGRADUATE = 49, // 民办-理工院校-职业本科
  PRIVATE_COMPREHENSIVE_INDEPENDENT_COLLEGE = 50, // 民办-综合大学-独立学院
  PRIVATE_POLYTECHNIC_INDEPENDENT_COLLEGE = 51, // 民办-理工院校-独立学院
  PRIVATE_MEDICAL_INDEPENDENT_COLLEGE = 52, // 民办-医药院校-独立学院
  PRIVATE_NORMAL_INDEPENDENT_COLLEGE = 53, // 民办-师范院校-独立学院
  PROVINCIAL_EDU_DEPT_NORMAL_COLLEGE = 54, // 省级教育部门-师范院校-学院
  PRIVATE_FINANCE_ECONOMICS_INDEPENDENT_COLLEGE = 55, // 民办-财经院校-独立学院
  PREFECTURAL_EDU_DEPT_MEDICAL_VOCATIONAL_COLLEGE = 56, // 地级教育部门-医药院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_SPORTS_VOCATIONAL_COLLEGE = 57, // 省级其他部门-体育院校-高等职业学校
  PRIVATE_ART_VOCATIONAL_COLLEGE = 58, // 民办-艺术院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_AGRICULTURAL_VOCATIONAL_COLLEGE = 59, // 省级其他部门-农业院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_LANGUAGE_COLLEGE = 60, // 省级其他部门-语文院校-学院
  PREFECTURAL_OTHER_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = 61, // 地级其他部门-理工院校-高等职业学校
  PROVINCIAL_OTHER_DEPT_ART_COLLEGE = 62, // 省级其他部门-艺术院校-学院
  PRIVATE_POLYTECHNIC_UNIV = 63, // 民办-理工院校-大学
  PROVINCIAL_OTHER_DEPT_MEDICAL_VOCATIONAL_UNDERGRADUATE = 64, // 省级其他部门-医药院校-职业本科
  SINO_FOREIGN_COOP_COMPREHENSIVE_UNIV = 65, // 具有法人资格的中外合作办-综合大学-大学
  PREFECTURAL_EDU_DEPT_NORMAL_JUNIOR_COLLEGE = 66, // 地级教育部门-师范院校-高等专科学校
  OTHER = 99, // 其他
}

export enum ESchoolTypeName {
  PRIMARY_SCHOOL = '小学（中小学）',
  JUNIOR_HIGH_SCHOOL = '初中（中小学）',
  HIGH_SCHOOL = '高中（中小学）',
  NINE_YEAR_CONSISTENT = '九年一贯（中小学）',
  TWELVE_YEAR_CONSISTENT = '十二年一贯（中小学）',
  COMPLETE_HIGH_SCHOOL = '完全高中（中小学）',
  VOCATIONAL_HIGH_SCHOOL = '职高（中小学）',
  TECHNICAL_SCHOOL = '技工（中小学）',
  SECONDARY_TECHNICAL_SCHOOL = '中专（中小学）',
  OTHER_SPECIAL_EDUCATION_SCHOOL = '其他特教学校（中小学）',
  SCHOOL_FOR_MENTAL_RETARDATION = '培智学校（中小学）',
  DEAF_SCHOOL = '聋人学校（中小学）',
  BLIND_SCHOOL = '盲人学校（中小学）',
  CENTRAL_EDU_DEPT_COMPREHENSIVE_UNIV = '中央教育部门-综合大学-大学（大中专）',
  PROVINCIAL_EDU_DEPT_POLYTECHNIC_UNIV = '省级教育部门-理工院校-大学（大中专）',
  PROVINCIAL_EDU_DEPT_AGRICULTURAL_UNIV = '省级教育部门-农业院校-大学（大中专）',
  PROVINCIAL_EDU_DEPT_FORESTRY_UNIV = '省级教育部门-林业院校-大学（大中专）',
  PROVINCIAL_EDU_DEPT_MEDICAL_UNIV = '省级教育部门-医药院校-大学（大中专）',
  PROVINCIAL_EDU_DEPT_NORMAL_UNIV = '省级教育部门-师范院校-大学（大中专）',
  PREFECTURAL_EDU_DEPT_NORMAL_UNIV = '地级教育部门-师范院校-大学（大中专）',
  PREFECTURAL_EDU_DEPT_NORMAL_COLLEGE = '地级教育部门-师范院校-学院（大中专）',
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_COLLEGE = '地级教育部门-综合大学-学院（大中专）',
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_UNIV = '地级教育部门-综合大学-大学（大中专）',
  PROVINCIAL_EDU_DEPT_FINANCE_ECONOMICS_UNIV = '省级教育部门-财经院校-大学（大中专）',
  PROVINCIAL_EDU_DEPT_COMPREHENSIVE_COLLEGE = '省级教育部门-综合大学-学院（大中专）',
  PROVINCIAL_EDU_DEPT_ART_COLLEGE = '省级教育部门-艺术院校-学院（大中专）',
  PREFECTURAL_EDU_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = '地级教育部门-综合大学-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_POLYTECHNIC_COLLEGE = '省级其他部门-理工院校-学院（大中专）',
  PROVINCIAL_EDU_DEPT_POLYTECHNIC_COLLEGE = '省级教育部门-理工院校-学院（大中专）',
  PREFECTURAL_EDU_DEPT_POLYTECHNIC_COLLEGE = '地级教育部门-理工院校-学院（大中专）',
  PROVINCIAL_OTHER_DEPT_POLITICAL_LAW_COLLEGE = '省级其他部门-政法院校-学院（大中专）',
  PROVINCIAL_EDU_DEPT_LANGUAGE_COLLEGE = '省级教育部门-语文院校-学院（大中专）',
  PRIVATE_COMPREHENSIVE_COLLEGE = '民办-综合大学-学院（大中专）',
  PROVINCIAL_OTHER_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = '省级其他部门-理工院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = '省级其他部门-财经院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = '省级其他部门-综合大学-高等职业学校（大中专）',
  PRIVATE_LANGUAGE_COLLEGE = '民办-语文院校-学院（大中专）',
  PROVINCIAL_OTHER_DEPT_ART_VOCATIONAL_COLLEGE = '省级其他部门-艺术院校-高等职业学校（大中专）',
  PRIVATE_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = '民办-财经院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_POLITICAL_LAW_VOCATIONAL_COLLEGE = '省级其他部门-政法院校-高等职业学校（大中专）',
  PROVINCIAL_EDU_DEPT_FINANCE_ECONOMICS_VOCATIONAL_COLLEGE = '省级教育部门-财经院校-高等职业学校（大中专）',
  PRIVATE_POLYTECHNIC_VOCATIONAL_COLLEGE = '民办-理工院校-高等职业学校（大中专）',
  PRIVATE_FINANCE_ECONOMICS_COLLEGE = '民办-财经院校-学院（大中专）',
  PRIVATE_COMPREHENSIVE_VOCATIONAL_COLLEGE = '民办-综合大学-高等职业学校（大中专）',
  COUNTY_OTHER_DEPT_COMPREHENSIVE_VOCATIONAL_COLLEGE = '县级其他部门-综合大学-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_MEDICAL_COLLEGE = '省级其他部门-医药院校-学院（大中专）',
  PREFECTURAL_EDU_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = '地级教育部门-理工院校-高等职业学校（大中专）',
  PRIVATE_POLYTECHNIC_VOCATIONAL_UNDERGRADUATE = '民办-理工院校-职业本科（大中专）',
  PRIVATE_COMPREHENSIVE_INDEPENDENT_COLLEGE = '民办-综合大学-独立学院（大中专）',
  PRIVATE_POLYTECHNIC_INDEPENDENT_COLLEGE = '民办-理工院校-独立学院（大中专）',
  PRIVATE_MEDICAL_INDEPENDENT_COLLEGE = '民办-医药院校-独立学院（大中专）',
  PRIVATE_NORMAL_INDEPENDENT_COLLEGE = '民办-师范院校-独立学院（大中专）',
  PROVINCIAL_EDU_DEPT_NORMAL_COLLEGE = '省级教育部门-师范院校-学院（大中专）',
  PRIVATE_FINANCE_ECONOMICS_INDEPENDENT_COLLEGE = '民办-财经院校-独立学院（大中专）',
  PREFECTURAL_EDU_DEPT_MEDICAL_VOCATIONAL_COLLEGE = '地级教育部门-医药院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_SPORTS_VOCATIONAL_COLLEGE = '省级其他部门-体育院校-高等职业学校（大中专）',
  PRIVATE_ART_VOCATIONAL_COLLEGE = '民办-艺术院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_AGRICULTURAL_VOCATIONAL_COLLEGE = '省级其他部门-农业院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_LANGUAGE_COLLEGE = '省级其他部门-语文院校-学院（大中专）',
  PREFECTURAL_OTHER_DEPT_POLYTECHNIC_VOCATIONAL_COLLEGE = '地级其他部门-理工院校-高等职业学校（大中专）',
  PROVINCIAL_OTHER_DEPT_ART_COLLEGE = '省级其他部门-艺术院校-学院（大中专）',
  PRIVATE_POLYTECHNIC_UNIV = '民办-理工院校-大学（大中专）',
  PROVINCIAL_OTHER_DEPT_MEDICAL_VOCATIONAL_UNDERGRADUATE = '省级其他部门-医药院校-职业本科（大中专）',
  SINO_FOREIGN_COOP_COMPREHENSIVE_UNIV = '具有法人资格的中外合作办-综合大学-大学（大中专）',
  PREFECTURAL_EDU_DEPT_NORMAL_JUNIOR_COLLEGE = '地级教育部门-师范院校-高等专科学校（大中专）',
  OTHER = '其他',
}

//门店性质
export enum ShopCharacter {
  SELFBOOK = 1,
  SELFNOTBOOK,
  CHAIN,
  FUNCTION,
  OTHER,
}
//门店性质
export enum ShopCharacterName {
  SELFBOOK = '自营图书',
  SELFNOTBOOK = '自营非图',
  CHAIN = '连锁',
  FUNCTION = '职能',
  OTHER = '其他',
}

//学校等级
export enum ESchoolGrade {
  FIRSTRATEA = 1,
  FIRSTRATEB,
  SUBJECT,
  REGULAR,
  INDEPENDENT,
  HIGHER,
  SECONDARY,
  SMALL,
  MIDDLE,
  OTHER,
}
//学校等级名称
export enum ESchoolGradeName {
  FIRSTRATEA = '双一流A',
  FIRSTRATEB = '双一流B',
  SUBJECT = '双一流学科',
  REGULAR = '本科',
  INDEPENDENT = '独立学院',
  HIGHER = '高职',
  SECONDARY = '中职',
  SMALL = '小学',
  MIDDLE = '中学',
  OTHER = '其他',
}

//门店类型
export enum ShopTypes {
  FLAGSHIP = 1,
  BENCHMARK,
  COMMUNITY,
  SCHOOL,
  OTHER,
}
//门店类型名称
export enum ShopTypesName {
  FLAGSHIP = '旗舰店',
  BENCHMARK = '标杆店',
  COMMUNITY = '社区店',
  SCHOOL = '校园店',
  OTHER = '其他',
}
//数据状态
export enum DataState {
  ALREADY = 1,
  DOWN,
  CHANGE,
}
//数据状态
export enum DataStateName {
  ALREADY = '已审国图',
  DOWN = '待审国图（下载）',
  CHANGE = '待审国图（转换）',
}

//客户类型
export enum ClientTypes {
  GENERAL,
  LIBRARY,
  SCHOOL,
  MICRO_LINKAGE,
}
//客户类型名称
export enum ClientTypesName {
  GENERAL = '通用',
  LIBRARY = '图书馆',
  SCHOOL = '学校',
  MICRO_LINKAGE = '小连锁',
}
//图书馆等级
export enum LibraryGrade {
  FIRST = 1,
  SECOND,
  THREE,
  PUBLIC,
  OTHER,
}
//图书馆等级名称
export enum LibraryGradeName {
  FIRST = '公共馆一级',
  SECOND = '公共馆二级',
  THREE = '公共馆三级',
  PUBLIC = '公共馆',
  OTHER = '其他',
}
//编目数据类型
export enum Catalogue {
  MAP = 1,
  CALIS,
  USMARC,
  NODATA,
}
//编目数据类型名称
export enum CatalogueName {
  MAP = '国图',
  CALIS = 'CALIS',
  USMARC = 'USMARC',
  NODATA = '不需要数据',
}
//门店业务类型
export enum ShopBusTypes {
  CRASH = 1,
  PICKUP,
  EXPRESSAGE,
  OFFLINE,
}
export enum ShopBusTypesName {
  CRASH = '闪送',
  PICKUP = '自提',
  EXPRESSAGE = '快递',
  OFFLINE = '线下服务',
}
// 是否终端客户
export enum TerminalClient {
  YES,
  NO,
}
// 是否终端名称
export enum TerminalClientName {
  YES = '是',
  NO = '否',
}
//是否存在公司
export enum IfCompanyExist {
  YES,
  NO,
}
//是否存在公司名称
export enum IfCompanyExistName {
  YES = '是',
  NO = '否',
}
// 经济性质（1-集团内组织；2-中外合资；3-民营企业；4-外资；5-个体工商户；6-国有企业独资及控股）
export enum EconomicNature {
  group, // 集团内组织
  out, // 中外合资
  private, // 民营企业
  foreign, // 外资
  individual, // 个体工商户
  own, // 国有企业独资及控股
}
export enum EconomicNatureName {
  group = '集团内组织',
  out = '中外合资',
  private = '民营企业',
  foreign = '外资',
  individual = '个体工商户',
  own = '国有企业独资及控股',
}
// 接口执行清盘状态
export enum HandleLiquidation {
  cancel = 0, // 取消清盘
  do = 2, // 清盘执行
}
// 清盘
export enum Liquidation {
  liquidation = 'liquidation', // 清盘
  cancel = 'cancelLiquidation', // 取消清盘
  do = 'doLiquidation', // 清盘执行
}
export enum LiquidationName {
  liquidation = '清盘', //
  cancel = '取消清盘', //
  do = '清盘执行', //
}

// 客户清盘/供应商清盘
export enum CSLiquidation {
  CLIENT = 'client', // 客户
  SUPPLIER = 'supplier', // 供应商
}
export enum CSLiquidationName {
  CLIENT = '客户', // 客户
  SUPPLIER = '供应商', // 供应商
}

// 查看/新建/编辑
export enum stateMachine {
  SEE = 'see', // 查看
  ADD = 'add', // 新增
  EDIT = 'edit', // 编辑
}
export enum EnumContactType {
  SHIPPING = 1,
  BUSINESS,
}
export enum EnumContactTypeName {
  SHIPPING = '收货',
  BUSINESS = '业务对接',
}
//查看类型
export enum EnumViewType {
  授信详情 = 0,
  授信明细 = 1,
}
// 授信操作类型
// 0-初始授信；1-额度变更；2-订单正向；3-冻结释放；4-订单逆向；5-还款
export enum EnumCreditOperationType {
  初始授信 = 0,
  额度变更 = 1,
  订单正向 = 2,
  // 冻结释放 = 3,
  订单逆向 = 4,
  还款 = 5,
}
export enum EnumQualificationsDtoListStatus {
  overDue,
  normal,
}
export enum EnumQualificationsDtoListStatusName {
  overDue = '已过期',
  normal = '正常',
}
export enum EnumQualificationsDtoListStatusColor {
  overDue = 'red',
  normal = 'green',
}
//审批状态 审核状态颜色（1：审核中 blue 、2：已通过 green、3：已驳回 red、4：已撤销 lime） 与合同中心的审批状态保持一致
export const enumApprovalStatus = { ...MapAuditStatus }
//审批状态颜色 审核状态颜色（1：审核中 blue 、2：已通过 green、3：已驳回 red、4：已撤销 lime） 与合同中心的审批状态保持一致
export const enumApprovalStatusColors = {
  ...MapAuditStatusColor,
}
